import React, { useCallback, useEffect, useState } from "react";
import Footer from "../Fotter";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteCartItem, viewCartData } from "../redux/slices/ViewCartSlice";
import { CustomeStyle } from "../Css/CustomeStyle";
import CustomBox from "../utli/CustomBox";
import { ConfirmOrder } from "../redux/slices/ConfirmOrderSlice";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";
import { toast } from "react-toastify";
import { ApplyCoupon } from "../redux/slices/ApplyCoupon";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import LoaderPage from "./Loader";

const Cart = () => {
  const navigate = useNavigate();
  const { ViewCart } = useSelector((state) => state.viewCart);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [itemId, setItemId] = useState(null);
  const storedUuid = localStorage.getItem("uuid");
  const [couponCode, setCouponCode] = useState("");
  const [loader, setLoader] = useState(false);

  // useEffect(() => {
  //   dispatch(viewCartData());
  // }, [dispatch]);

  useEffect(() => {
    const fetchCart = async () => {
      setLoader(true);
      try {
        await dispatch(viewCartData());
      } catch (err) {
        console.error("Error fetching cart:", err);
      } finally {
        setLoader(false);
      }
    };

    fetchCart();
  }, [dispatch]);


  const increaseQuantity = async (item) => {
    try {
      const Token = localStorage.getItem("loginData");
      const response = await axios.patch(
        `${endPoint.UPDATECART}`,
        {
          quantity: item?.quantity + 1,
          productId: item?.productId,
        },
        {
          headers: {
            sessionId: storedUuid ? storedUuid : "",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      dispatch(viewCartData());
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const decreaseQuantity = async (item) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      if (item?.quantity - 1 === 0) {
        dispatch(deleteCartItem(item?.productId));
      } else {
        const response = await axios.patch(`${endPoint.UPDATECART}`, {
          quantity: item?.quantity - 1,
          sessionId: storedUuid,
          productId: item?.productId,
        });
        dispatch(viewCartData());
        return response.data;
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleRemoveFromCart = (id) => {
    setItemId(id);
    setShowModal(true);
  };

  const handleConfirmRemove = () => {
    dispatch(deleteCartItem(itemId));
    setShowModal(false);
  };

  const handleCloseBox = () => {
    setShowModal(false);
  };

  const _handleClick = () => {
    navigate("/");
  };

  const _handleCheckout = () => {
    dispatch(ConfirmOrder())
      .unwrap()
      .then((response) => {
        navigate("/Checkout");
      })
      .catch((error) => {
        console.error("Error placing order:", error);
        alert("Failed to place order. Please try again.");
      });
  };

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      toast.error("Please enter a coupon code!", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }
    setLoader(true);
    dispatch(ApplyCoupon(couponCode)).then((result) => {
      setLoader(false);
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
      } else {
        setLoader(false);
        toast.error("Invaild Coupon Code", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
            borderRadius: "8px",
          },
        });
      }
    });
  };

  const generateSlug = (text) => {
    if (!text) return "";

    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\- ]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };


  const _handlewAddCart = useCallback((item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        toast.error("Responce Error!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      }
    });
  });

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 ">
      <div className="flex-grow">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {ViewCart?.cart?.length > 0 ? (
            <div className="bg-white rounded-sm">
              <div className="mx-auto flex items-center  mb-4 w-full px-3 sm:mt-5 mt-0 justify-between">
                <button
                  onClick={() => navigate(-1)}
                  className="mr-2 bg-gray-200 px-2 py-2 rounded-full flex items-center"
                >
                  <AiOutlineArrowLeft className="text-lg mr-1" />
                </button>
                <h3 className="font-bold text-lg sm:text-xl mb-4 sm:mb-6">
                  Cart Items
                </h3>
                <h1></h1>
              </div>
              {ViewCart?.cart?.map((item) => {
                return (
                  <div
                    key={item.productId}
                    className="flex flex-wrap sm:flex-nowrap items-start gap-4 sm:gap-6 sm:mb-6  p-4  sm:p-6  border-b pb-4 sm:pb-6"
                  >
                    {/* Product Image */}
                    <img
                      loading="lazy"
                      src={item?.productImage}
                      alt={item?.title}
                      className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-lg flex-shrink-0"
                    />

                    <div className="flex-1 flex flex-col justify-between">
                      <Link
                        to={`/shop/${item?.category
                          ? generateSlug(item?.category)
                          : "-"
                          }/${item?.subcategory
                            ? generateSlug(item?.subcategory)
                            : "-"
                          }/${generateSlug(item?.title)}`}
                        state={{ item: item }}
                        className="flex flex-col gap-2">
                        <h4 className="text-base sm:text-lg font-semibold text-gray-800 line-clamp-2">
                          {item?.title}
                        </h4>

                        <div className="flex items-center gap-2">
                          <span className="text-lg font-semibold text-black">
                            Price :-
                          </span>
                          <span className="text-lg font-semibold text-black">
                            ₹{item?.salePrice}
                          </span>
                          <span className="text-sm line-through text-gray-500">
                            ₹{item?.regularPrice}
                          </span>
                          {item?.isCodeAvailable &&
                            <div className="text-xl  items-center gap-2 ms-2 sm:block hidden">
                              <span className=" bg-gradient-to-r from-red-500 to-red-500 text-white text-xs font-bold px-2 py-1 rounded-br-xl shadow animate-pulse">
                                Cod Available
                              </span>
                            </div>
                          }
                        </div>
                        {item?.appliedCoupon && (
                          <>
                            <div className="flex items-center gap-2">
                              <span className="text-lg font-semibold text-black">
                                Applied Coupon Code :-
                              </span>
                              <span className="text-lg font-semibold text-black">
                                {item?.appliedCoupon?.couponCode}
                              </span>
                            </div>
                            <div className=" text-lg  text-gray-600">
                              <span className="text-lg font-semibold text-black">
                                Discount :-{" "}
                              </span>
                              <span className="text-black font-semibold ms-2">
                                {item?.appliedCoupon?.discountType == "fixed" &&
                                  "₹"}
                                {item?.appliedCoupon?.discountValue}{" "}
                                {item?.appliedCoupon?.discountType == "fixed"
                                  ? ""
                                  : "%"}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="text-lg font-semibold text-black">
                                Discount Price :-
                              </span>
                              <span className="text-lg font-semibold text-black">
                                ₹{item?.finalPrice}
                              </span>
                              <span className="text-xs line-through text-gray-500">
                                ₹{item?.totalBeforeCoupon}
                              </span>
                            </div>
                          </>
                        )}

                        <div className="text-sm text-gray-600 flex gap-4 flex-wrap">
                          {item.size && <span>Size: {item.size}</span>}
                          {item.color && <span>Color: {item.color}</span>}
                        </div>
                      </Link>

                      {!item?.associatedWithMainProduct &&
                        <div className="flex items-center gap-4 mt-1 sm:mt-2">
                          <button
                            className="h-8 w-8 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-200"
                            onClick={() => decreaseQuantity(item)}
                          >
                            -
                          </button>
                          <span className="text-lg font-semibold text-gray-800">
                            {item.quantity}
                          </span>
                          <button
                            className="h-8 w-8 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-200"
                            onClick={() => increaseQuantity(item)}
                          >
                            +
                          </button>
                        </div>
                      }
                    </div>

                    {/* Remove Button */}
                    {!item?.associatedWithMainProduct &&
                      <div className="w-full sm:w-auto mt-1 sm:mt-0">
                        <button
                          className="w-full sm:w-auto bg-gray-200 border border-gray-400 text-gray-600 px-4 py-2 rounded hover:bg-gray-400 hover:text-white transition"
                          onClick={() => handleRemoveFromCart(item.productId)}
                        >
                          Remove
                        </button>
                      </div>
                    }
                  </div>
                );
              })}
              <div className="bg-white p-4 sm:p-6 rounded-lg border border-gray-200 mb-6">
                <h3 className="font-semibold text-xl sm:text-2xl text-gray-800 mb-4">
                  Apply Coupon
                </h3>
                <div className="flex gap-2 sm:gap-4">
                  <input
                    type="text"
                    className="border p-2 rounded w-full"
                    placeholder="Enter Coupon Code"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <button
                    onClick={handleApplyCoupon}
                    className="bg-orange-400 text-white sm:px-10 px-3 py-2 rounded hover:bg-orange-600 transition"
                  >
                    Apply
                  </button>
                </div>
              </div>

              {ViewCart?.suggestedAccessories && ViewCart?.suggestedAccessories.length > 0 && (
                <div className="mt-10 px-4 sm:px-6 lg:px-8">
                  <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
                    You May Also Like
                  </h2>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {ViewCart?.suggestedAccessories.map((item, index) => (
                      <Link
                        to={`/shop/${item?.category
                          ? generateSlug(item?.category)
                          : "-"
                          }/${item?.subcategory
                            ? generateSlug(item?.subcategory)
                            : "-"
                          }/${generateSlug(item?.title)}`}
                        state={{ item: item }}
                        className="flex flex-col gap-2">
                        <div
                          key={index}
                          className="bg-white shadow-lg rounded-xl p-4 hover:shadow-2xl transition duration-300 flex flex-col justify-between"
                        >
                          <img
                            src={`https://addmecart.com/${item?.productimage1}`}
                            alt={item?.productname || "Product Image"}
                            className="w-full h-48 object-cover rounded-md"
                          />

                          <div className="mt-4 flex flex-col justify-between flex-grow">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                              {item?.title}
                            </h3>

                            <div className="flex item-center gap-2 mb-4">
                              <span className="text-lg font-semibold text-black text-green-600">
                                ₹{item?.price}
                              </span>
                              <span className=" line-through text-gray-500 text-lg">
                                ₹{item?.regularPrice}
                              </span>
                            </div>
                            <button onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              _handlewAddCart(item)
                            }}
                              className="w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition font-semibold">
                              Add to Cart
                            </button>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}

              <div className="bg-slate-100 p-5 rounded-lg mb-6 border border-gray-200 mt-10">
                <h3 className="font-semibold text-2xl sm:text-3xl text-gray-800 mb-4 text-center">
                  Price Details
                </h3>
                <div className="flex justify-between text-lg mt-3 text-gray-600">
                  <span>Shipping Charges</span>
                  <span className="text-black font-semibold">
                    ₹ {ViewCart?.shippingCost}
                  </span>
                </div>

                <div className="flex justify-between text-lg mt-3 text-gray-600">
                  <span>Free Shipping Order Above 2500</span>
                </div>

                <div className="flex justify-between text-xl sm:text-2xl font-semibold mt-5 text-gray-800">
                  <span>Total Amount</span>
                  <span className="text-xl text-green-600">
                    ₹ {ViewCart?.finalPrice.toFixed(2)}
                  </span>
                </div>
              </div>

              <div className="text-center mb-5">
                <button
                  onClick={() => _handleCheckout()}
                  //  navigate("/Checkout")}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-semibold w-64 sm:w-80"
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="flex justify-center items-start mt-[10%]">
                <h1 className={`${CustomeStyle.headerText} text-center`}>Cart</h1>
              </div>{" "}
              <div className="flex items-center justify-center mt-[5%] w-full h-[200px]">
                <div className="bg-gradient-to-r from-yellow-200 via-yellow-100 to-yellow-100 h-48 w-[90%] border-gray-300 rounded-lg shadow-lg flex items-center justify-center mx-auto">
                  <p className="text-black text-lg font-semibold">
                    Your cart is currently empty.
                  </p>
                </div>
              </div>
              <button
                onClick={() => _handleClick()}
                className="mb-5 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-300 flex justify-center items-center mx-auto mt-10"
              >
                Return to Shop
              </button>
            </>
          )}
        </div>
        <CustomBox
          show={showModal}
          message="Are you sure you want to remove this item from your cart?"
          onCancel={handleCloseBox}
          onConfirm={handleConfirmRemove}
        />
      </div>
      {loader && <LoaderPage />}
      <Footer className="fixed" />
    </div>
  );
};

export default Cart;
